var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BSGLink',{staticClass:"common-video-navbar-item",class:{
    active: _vm.isActive,
  },attrs:{"to":_vm.to,"title":_vm.text}},[_c('BSGIcon',{attrs:{"name":_vm.icon,"size":24,"color":"neutral-800"}}),_vm._v(" "),(_vm.text)?_c('div',{staticClass:"text -md:hidden"},[_vm._v(_vm._s(_vm.text))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }